import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactElement, ReactNode } from 'react'
import { useMemo } from 'react'

const withQueryClientProvider = <T extends object>(Component: (props: T) => ReactNode) => {
  const WithQueryClient = (props: T): ReactElement => {
    const queryClient = useMemo(() => new QueryClient(), [])
    return (
      <QueryClientProvider client={queryClient}>
        <Component {...props} />
      </QueryClientProvider>
    )
  }
  return WithQueryClient
}
export default withQueryClientProvider
